module.exports = __webpack_public_path__ + "fonts/title-font.f3d23528.ttf";